import { plural } from "@amber/contracts";
import { formatBytes, formatCount } from "@amber/ui";
import type { HomeFrame } from "@amber/application/contracts";

export const FRAME_OPTIONS = [
  { value: "24h", label: "24 h" },
  { value: "7d", label: "7 d" },
  { value: "30d", label: "30 d" },
] as const satisfies readonly { value: HomeFrame; label: string }[];
export const FRAME_TEXT: Record<HomeFrame, string> = {
  "24h": "Last 24 hours",
  "7d": "Last 7 days",
  "30d": "Last 30 days",
};
export const FRAME_SHORT: Record<HomeFrame, string> = { "24h": "24 hours", "7d": "7 days", "30d": "30 days" };
export const FRAME_DAYS: Record<HomeFrame, number> = { "24h": 1, "7d": 7, "30d": 30 };

export function usd(value: number, precise = false): string {
  if (precise || value < 10) return `USD ${value.toFixed(2)}`;
  return `USD ${formatCount(value)}`;
}

export function hoursText(h: number | null): string {
  if (h === null) return "—";
  if (h < 1) return `${String(Math.max(1, Math.round(h * 60)))} min`;
  if (h <= 48) return `${String(Math.round(h))} h`;
  return `${String(Math.round(h / 24))} d`;
}

export function mediaText(seconds: number, pages: number): string {
  const parts = [
    seconds > 0
      ? `${formatCount(seconds / 3600 < 1 ? Math.ceil(seconds / 60) : seconds / 3600)} ${seconds / 3600 < 1 ? "min" : "h"}`
      : null,
    pages > 0 ? plural(pages, "page", { format: formatCount }) : null,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(" · ") : "—";
}

export function weekly(items: number, b: number): string {
  return `+${items < 1 && items > 0 ? items.toFixed(1) : formatCount(items)} items · +${formatBytes(b)}`;
}
